export const authToken = () => localStorage.getItem("auth-token");

export const devlog =
  process.env.NODE_ENV === "development" ? console.log : function(...param: any[]) {};
